import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authenticationService } from '../services/authenticationService';
import { addNotificationWithTimeout } from '../app/addNotificationWithTimeout';

export const Logout = () => {
    const dispatch = useDispatch();

    useEffect(() => {     
        const baseTitle = "OTT";
        document.title = "Logout";

        if (baseTitle !== "") {
            document.title += ` | ${baseTitle}`;
        }

        let logoutRedirectUrl = "/";
        const currentUser = authenticationService.currentUserValue;
        if (currentUser && currentUser.logoutRedirectUrl) {
            logoutRedirectUrl = currentUser.logoutRedirectUrl;
        }
        
        const logoutPromise = authenticationService.logout();

        logoutPromise
            .then(() => {                
                window.location = logoutRedirectUrl;
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }, []);

    return (
        <></>
    );
}